import { render, staticRenderFns } from "./shiftDialog.vue?vue&type=template&id=47050c52&scoped=true"
import script from "./shiftDialog.vue?vue&type=script&lang=js"
export * from "./shiftDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47050c52",
  null
  
)

export default component.exports